/**
 * Add-on price text from GET /api/v1/me/addons/catalogue.
 *
 * The figure is what the card is charged for one unit: `charge_pence` (VAT
 * included when Hermes adds VAT), falling back to `price_pence` when Hermes sends
 * no VAT figures (a Hermes without VAT charges the price as written). "inc. VAT"
 * is shown only when Hermes's own figures (`vat_rate`, `vat_pence`) say VAT is in
 * the charge. No price or rate here is a Yorlin constant.
 */

/** The catalogue entry (with its key) for a usage meter, or null. */
export function addonForMeter(catalogue, meter) {
  const found = Object.entries(catalogue || {}).find(([, v]) => v && v.meter === meter);
  return found ? { key: found[0], ...found[1] } : null;
}

/** e.g. "£18 inc. VAT", "£6/mo inc. VAT", or "£1" when no VAT is charged. */
export function addonPriceText(entry, currency = 'GBP') {
  if (!entry) return '';
  const unit = Number(entry.charge_pence ?? entry.price_pence);
  if (!Number.isFinite(unit) || unit <= 0) return '';
  const symbol = currency === 'GBP' ? '£' : '';
  const money = symbol + (unit / 100).toFixed(2).replace(/\.00$/, '');
  const per = entry.mode === 'recurring' ? '/mo' : '';
  const vat = Number(entry.vat_rate) > 0 && Number(entry.vat_pence) > 0 ? ' inc. VAT' : '';
  return money + per + vat;
}

/** Load the catalogue; resolves {catalogue, currency}, or empty on failure. */
export async function loadAddonCatalogue(api) {
  try {
    const res = await api.get('/api/v1/me/addons/catalogue');
    const body = res?.data?.data ?? res?.data ?? res;
    return { catalogue: body?.catalogue ?? {}, currency: body?.currency ?? 'GBP' };
  } catch (e) {
    return { catalogue: {}, currency: 'GBP' };
  }
}
